import { createVanIconComponent } from "./van"

const AwardOutlined = createVanIconComponent("award-o")
export default AwardOutlined
